import PropTypes from 'prop-types';
import React from 'react';
import { Modal, TFVButton } from '../../../Share/components';
import { isIE } from '../../../Share/utils';

function ShowPassword({ isVisible = false, onClose = () => {}, details = {} }) {
  return (
    <Modal
      isVisible={isVisible}
      onCloseClicked={onClose}
      headerText="Engångslösenord"
      className="tv-cancel-license__modal"
      headerClassName="tv-create-license__modal-header"
      ieOptionClassName={isIE ? 'ie-fix-height' : ''}
    >
      <p className="mb-4">Engångslösenord för {details.UserName}:</p>
      <p className="mb-4">{details.OneTimePassword}</p>
      <p className="mb-4">
        Efter första inloggning väljer användaren ett nytt lösenord.
      </p>
    </Modal>
  );
}

ShowPassword.prototype = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  details: PropTypes.shape({
    OneTimePassword: PropTypes.string,
    UserName: PropTypes.string,
  }),
};

export default ShowPassword;
